<template>
	<el-table
		ref="table"
		size="medium"
		style="width: 100%"
		:border="border"
		:header-cell-style="headerCellStyle"
		:height="table_height"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot></slot>
		<template v-slot:empty>
			<div style="line-height: 1.5">
				<img class="l-no-data-img" src="@/assets/images/no_data.png" />
				<div class="l-no-data-text">暂无数据</div>
			</div>
		</template>
	</el-table>
</template>

<script>
export default {
	name: "l-table",
	props: {
		height: {
			default: "0",
		},
		border: {
			default: true,
		},
		offsetHeight: {
			type: Number,
			default: 175,
		},
		headerCellStyle: {
			default: () => {
				return { background: "#f8f8f9", color: "#333" };
			},
		},
	},
	data() {
		return {
			table_height: 0,
		};
	},
	mounted() {
		if (this.$props.height == 0) {
			this.$nextTick(() => {
				this.table_height = window.innerHeight - this.$refs.table.$el.offsetTop - this.$props.offsetHeight;
				// console.log(this.$refs.table.$el.offsetTop, this.$props.offsetHeight, this.table_height, window.innerHeight);
				// console.log(this.$refs.table.$el.scrollTop);
			});
		} else {
			this.$nextTick(() => {
				this.table_height = this.$props.height;
				// console.log(this.height, this.table_height);
			});
		}
	},

	methods: {
		//清空所有选择
		clearSelection() {
			this.$refs.table.clearSelection();
		},
		toggleRowSelection(row, selected) {
			this.$refs.table.toggleRowSelection(row, selected);
		},
		toggleRowExpansion(row, ...option) {
			this.$refs.table.toggleRowExpansion(row, ...option);
		},
	},
};
</script>
